import { Component, OnInit } from '@angular/core';
import { MessagingService } from './services/messaging/messaging.service';
import { FirebaseAuth } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { take } from 'rxjs/operators';
import { first, filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  msg;

  constructor(
    private msgService: MessagingService,
    public auth: AngularFireAuth
  ) {}

  ngOnInit() {
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!iOS && !isSafari) {
      this.auth.user
        .pipe(filter(user => !!user))
        .pipe(take(1))
        .subscribe(user => {
          if (user && navigator.appName !== 'Safari') {
            this.msgService.getPermission(user);
            this.msgService.monitorRefresh(user);
            this.msgService.receiveMessages();
          }
        });
    }
  }

  getUser() {
    return localStorage.getItem('dffUser');
  }
}
